import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { DEQ_TYPES } from '../../../utils/deq';

import mq from '../../../styles/breakpoints';
import Colors from '../../../styles/colors';
import { SmallText } from '../../../styles/generic';

import CloseIcon from '../icons/CloseIcon';
import SmallInfoIcon from '../icons/SmallInfoIcon';
import SmallLockIcon from '../icons/SmallLockIcon';

export const FORM_TYPES = {
  lock: 'lock',
  info: 'info',
};

interface Props {
  type: string;
  isNotificationOpen?: boolean;
  onNotificationClick?: (event: boolean) => void;
  children: ReactNode;
  className?: string;
}

const FormMessage = ({
  children,
  type,
  isNotificationOpen = true,
  onNotificationClick = undefined,
  className,
}: Props) => {
  if (isNotificationOpen) {
    return (
      <Container type={type} data-testid="form-message" className={className}>
        {type === FORM_TYPES.lock && (
          <StyledSmallLockIcon color={Colors.abnPrivacy400} />
        )}
        {type === FORM_TYPES.info && (
          <StyledSmallInfoIcon color={Colors.abnBlue01} />
        )}
        <Description>{children}</Description>
        {onNotificationClick && (
          <CancelButton
            data-testid="cancel-button"
            data-element-label="close message"
            data-component-type="form-message"
            data-element-type={DEQ_TYPES.btnImage}
            onClick={() => onNotificationClick && onNotificationClick(false)}
          >
            <CloseIcon color={Colors.abnNeutral10} width="14" height="14" />
          </CancelButton>
        )}
      </Container>
    );
  }
  return null;
};

export default FormMessage;

const Container = styled.div<{ type?: string }>`
  background: ${Colors.white};
  border-bottom: 1px solid ${Colors.abnNeutral55};
  border-left: 4px solid
    ${({ type }) =>
      type === FORM_TYPES.lock ? Colors.abnPrivacy400 : Colors.abnBlue01};
  border-radius: ${({ theme }) => theme.radiuses.M};
  border-right: 1px solid ${Colors.abnNeutral55};
  border-top: 1px solid ${Colors.abnNeutral55};
  box-sizing: border-box;
  display: flex;
  height: auto;
  margin-bottom: 24px;
  padding: 18px 42px 18px 18px;
  position: relative;
  width: 100%;
`;

const Description = styled(SmallText)`
  margin: 0;

  a {
    color: ${({ theme }) => theme.colors.abnGreen300};

    &:hover {
      color: ${Colors.abnBlack};
    }
  }

  p {
    margin: 0;
  }
`;

const IconStyles = css`
  flex: none;
  margin-right: 10px;
`;

const StyledSmallLockIcon = styled(SmallLockIcon)`
  ${IconStyles}
`;

const StyledSmallInfoIcon = styled(SmallInfoIcon)`
  ${IconStyles}
`;

const CancelButton = styled.a`
  cursor: pointer;
  display: block;
  height: 14px;
  position: absolute;
  right: 18px;
  text-decoration: none;
  top: 18px;
  transform: translateY(0);
  width: 14px;

  ${mq.from.breakpoint.M`
    top: 22px;
  `}
`;
